import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CollectorAvailabilityOverviewParams,
  CollectorAvailabilityOverviewResponse,
  CollectorAvailabilitySkillConfig
} from '../domain/collector-availability-overview.model';

@Injectable({
  providedIn: 'root'
})
export class CollectorAvailabilityOverviewService {
  private readonly url =
    environment.API_HOST + '/api/dc-rosters/schedule/availability-overview';

  constructor(private http: HttpClient) {}

  getSkillConfig(): Observable<CollectorAvailabilitySkillConfig> {
    return this.http.get<CollectorAvailabilitySkillConfig>(
      `${this.url}/skill-config`
    );
  }

  getOverview(
    request: CollectorAvailabilityOverviewParams
  ): Observable<CollectorAvailabilityOverviewResponse> {
    let params = new HttpParams()
      .set('date', request.date)
      .set('fromMinute', request.fromMinute)
      .set('toMinute', request.toMinute)
      .set('availabilityFilter', request.availabilityFilter)
      .set('sort', request.sort)
      .set('page', request.page)
      .set('pageSize', request.pageSize);

    const team = request.team?.trim();
    if (team) {
      params = params.set('team', team);
    }

    const query = request.query?.trim();
    if (query) {
      params = params.set('query', query);
    }

    const skill = request.skill?.trim();
    if (skill) {
      params = params.set('skill', skill);
    }

    return this.http.get<CollectorAvailabilityOverviewResponse>(this.url, {
      params
    });
  }
}
